module.exports = __webpack_public_path__ + "img/tourhead-50.ae74e374.jpg";